import { render, staticRenderFns } from "./MissingDataModal.vue?vue&type=template&id=3965d6c4&scoped=true"
import script from "./MissingDataModal.vue?vue&type=script&lang=js"
export * from "./MissingDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965d6c4",
  null
  
)

export default component.exports